export enum Side {
  Front = 'front',
  Back = 'back',
}

export enum Variant {
  Top = 'top',
  Bottom = 'bottom',
}
